import { createContext, useContext } from "react";
import type { PortalContextValue } from "@/lib/portalSession";

export const PortalUserContext = createContext<PortalContextValue | null>(null);

export function usePortalUserContext(): PortalContextValue | null {
  return useContext(PortalUserContext);
}
